// Interface
import { renderIf } from "@/Common/helpers/sonar";
import { IAccessListLoadingProps } from "../interfaces";

// MUI
import { Grid, Skeleton, Stack } from "@mui/material";

// Layouts
import SearchInput from "@/Layouts/components/Basics/SearchInput";
import ActionCard from "@Layouts/components/Cards/ActionCard/ActionCard";
import clsx from "clsx";

export const AccessListLoading = (props: IAccessListLoadingProps) => {
	const { accessType = "", searchable = false, hasTabs = false } = props;

	return (
		<>
			{renderIf(
				searchable,
				<Stack position={"absolute"} width={1} justifyContent={"center"} className="z-10">
					<Grid container className={"dialog-search-container h-[60px] bg-white"} justifyContent={"center"}>
						<Grid item xs={6}>
							<SearchInput value={""} loading={true} sx={{ backgroundColor: "transparent !important" }} />
						</Grid>
					</Grid>
				</Stack>
			)}
			{renderIf(
				!searchable,
				<Stack direction={"row"} spacing={1} mb={1} ml={1.4} alignItems={"center"}>
					<Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: "2px" }} />
					<Skeleton variant="rectangular" width={200} height={15} sx={{ borderRadius: "4px" }} />
				</Stack>
			)}
			{renderIf(
				hasTabs,
				<Stack width={1} justifyContent={"center"} className="z-10 mt-20">
					<Grid container className={"dialog-search-container h-[60px] bg-white"} justifyContent={"center"} gap={2}>
						<Stack direction={"row"} spacing={1} justifyContent={"center"}>
							<Skeleton variant="rectangular" width={130} height={35} sx={{ borderRadius: "5px" }} />
						</Stack>
						<Stack direction={"row"} spacing={1} justifyContent={"center"}>
							<Skeleton variant="rectangular" width={130} height={35} sx={{ borderRadius: "5px" }} />
						</Stack>
					</Grid>
				</Stack>
			)}
			<Grid
				container
				className={clsx([{ "!w-full !m-0 !pl-2 !pr-6": true }, { "!mt-[10px]": hasTabs }, { "!mt-[60px] ": !hasTabs }])}
				alignContent={"flex-start"}
				spacing={2}
			>
				{Array.from(Array(6)).map((_, key) => {
					const itemKey = `loading_action_card_${accessType}_${key}`;
					return (
						<Grid key={itemKey} item xs={6} md={4}>
							<ActionCard classes={"action-card-br-10"} checkbox title content loading={true} />
						</Grid>
					);
				})}
			</Grid>
		</>
	);
};
